import axios from 'axios';
import apiConfig from '../api.config';

export default function getHotelDoorOpeningConfig({ platform, hotelId, doorOpeningId }) {
  const {
    host,
    URIs: { doorOpeningConfig },
  } = apiConfig;

  const uri = `${host}${doorOpeningConfig.replace(':platform', platform.toLowerCase())}`;

  return axios
    .get(uri, {
      params: {
        hotelId,
        doorOpeningId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
